import { Typography, Stack } from '@mui/material'
import * as React from 'react'
import { useAuth } from '../Auth'

function UserAccountPage() {
  const { currentUser } = useAuth()

  return (
    <Stack p={2}>
      <Typography color="black" variant="h4">
        User Account
      </Typography>
      <Detail label="Name" text={currentUser.name} />
      <Detail label="Emai" text={currentUser.email} />
      <Detail label="Phone" text={currentUser.phone} />
      <Detail label="Role" text={currentUser.role.type} />
    </Stack>
  )
}

function Detail({ label, text }: { label: string; text: string }) {
  return (
    <Typography fontWeight="bold">
      {label}:<Typography component={'span'}> {text}</Typography>
    </Typography>
  )
}

export default UserAccountPage
